import { ReactNode } from 'react';
import { AdFooter, App, Maybe, NavigationLink, Page } from '@src/lib/__generated/sdk';
import { Footer, FooterAlt, FooterLite, Header, Teletriage } from '@src/lib/shared-components-web';
import { IBanner } from '@src/lib/shared-components-web/components/Banner/Banner';
import { IGoogleMap } from '@src/lib/shared-components-web/components/GoogleMap/GoogleMap';
interface LayoutPropsInterface {
  children: ReactNode;
  appData: Maybe<App>;
  footerData: Maybe<AdFooter>;
  isFooterLite?: boolean;
  isFooterAlt?: boolean;
  withSimpleLayout?: boolean;
  showHeaderNavMenu: boolean;
  breadcrumbsData: Page;
  locationNavigationLinks?: Array<NavigationLink | Page>;
  withFixedHeader: boolean;
  disableStickyFooterOnMobile: boolean | null;
  disableStickyFooterOnDesktop: boolean | null;
  disableHeaderTopAlertBanner: boolean | null;
  disableHeaderBottomAlertBanner: boolean | null;
  hideLocation?: boolean;
  hidePrimaryActionButton?: boolean;
  logoHref?: string;
  hideNavigation?: boolean;
}
function getFooter(footerData: Maybe<AdFooter>, isFooterLite: boolean, isFooterAlt: boolean, withSimpleLayout: boolean, breadcrumbsData: Page | undefined, disableStickyFooterOnMobile: boolean | null, disableStickyFooterOnDesktop: boolean | null) {
  if (isFooterLite) {
    return <FooterLite disclaimer={footerData?.disclaimer as any} footerData={footerData as any} breadcrumbsData={breadcrumbsData as any} />;
  }
  if (isFooterAlt) {
    return <FooterAlt footerData={footerData as any} />;
  }
  return <Footer footerData={footerData as any} withScheduling={withSimpleLayout} breadcrumbsData={breadcrumbsData as any} isLightFooter={!!footerData?.isLightFooter} disableStickyFooterOnMobile={disableStickyFooterOnMobile} disableStickyFooterOnDesktop={disableStickyFooterOnDesktop} data-sentry-element="Footer" data-sentry-component="getFooter" data-sentry-source-file="layout.tsx" />;
}
export const Layout = ({
  appData,
  footerData,
  isFooterLite = true,
  isFooterAlt = false,
  withSimpleLayout = false,
  children,
  showHeaderNavMenu,
  breadcrumbsData,
  locationNavigationLinks,
  withFixedHeader,
  disableStickyFooterOnMobile,
  disableStickyFooterOnDesktop,
  hideLocation = false,
  hidePrimaryActionButton = false,
  disableHeaderTopAlertBanner,
  disableHeaderBottomAlertBanner,
  logoHref,
  hideNavigation = false
}: LayoutPropsInterface) => {
  const headerComponent = <Header locationNavigationLinks={locationNavigationLinks as any} appData={appData as any} logoHref={logoHref} withOfficeDetails showHeaderNavMenu={hideNavigation ? false : showHeaderNavMenu} phoneNumber={appData?.header?.phoneNumber as any} withFixedHeader={withFixedHeader} useHeaderLocationCards={appData?.header?.useHeaderLocationCards} hideLocation={hideLocation} hidePrimaryActionButton={hidePrimaryActionButton} googleMapsForLocationCards={appData?.header?.googleMapsForLocationCards as IGoogleMap} topAlertBanner={appData?.header?.topAlertBanner as IBanner} bottomAlertBanner={appData?.header?.bottomAlertBanner as IBanner} disableHeaderTopAlertBanner={disableHeaderTopAlertBanner} disableHeaderBottomAlertBanner={disableHeaderBottomAlertBanner} />;
  return <>
			{appData && <>{headerComponent}</>}
			{children}
			<Teletriage data-sentry-element="Teletriage" data-sentry-source-file="layout.tsx" />
			{footerData && getFooter(footerData, isFooterLite, isFooterAlt, withSimpleLayout, breadcrumbsData, disableStickyFooterOnMobile, disableStickyFooterOnDesktop)}
		</>;
};